(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    // Product videos are rendered with autoplay; keep them playing if the tab was hidden at load or something pauses them programmatically.
  (function () {
    if (window.__puleraAutoplayGuard) return;
    window.__puleraAutoplayGuard = true;
    var selector = '.product-media deferred-media[autoplay] > video';
    function play(video) {
      video.muted = true;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
    function kick() {
      document.querySelectorAll(selector).forEach(play);
    }
    document.addEventListener('pause', function (e) {
      var v = e.target;
      if (v && v.matches && v.matches(selector) && !v.ended) play(v);
    }, true);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) kick();
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', kick);
    } else {
      kick();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
